/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useMemo } from 'react'
import { useBlockUI, useHttpClient } from '../../../../modules/services/Bundle'
import { EnumUsuarioTipo, RequestMethod } from '../../../../modules/services/core/_enums'
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik'
import { useLocation, useNavigate } from 'react-router-dom'
import { defaultValidationSchemas, initialValues } from './helpers/UsuarioHelper'
import Select from 'react-select'
import { IPerfilModel } from '../../../../modules/services/core/_models'
import { info } from 'console'

// Função utilitária para aplicar máscara de celular
const applyPhoneMask = (value: string): string => {
  // Remove todos os caracteres não numéricos
  const numbers = value.replace(/\D/g, '');

  // Aplica a máscara baseada no tamanho
  if (numbers.length <= 2) {
    return numbers.replace(/(\d{0,2})/, '($1');
  } else if (numbers.length <= 7) {
    return numbers.replace(/(\d{2})(\d{0,5})/, '($1) $2');
  } else if (numbers.length <= 11) {
    return numbers.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
  }

  // Limita a 11 dígitos
  return numbers.substring(0, 11).replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
};

interface Dados {
  idUsuario: string
  tipo: number
  visualizar: boolean
  title: string
}

const UsuarioEdit = () => {
  console.log('🔵 COMPONENTE UsuarioEdit.tsx CARREGADO - VERSÃO COM EDITARR')
  const httpClient = useHttpClient()
  const navigate = useNavigate()
  const location = useLocation()
  const state = location.state as Dados
  const informacao: Dados = state
  const { setBlocking } = useBlockUI()
  const [perfis, setPerfis] = useState<IPerfilModel[]>([])
  const [organizacoes, setOrganizacoes] = useState<{
    OrganizationId: number;
    OrganizationName: string;
    Idcorporacao: number;
    CorporationName: string;
  }[]>([]);
  // Estado para mostrar modal de sucesso
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');

  const formik = useFormik({
    initialValues: { ...initialValues, OrganizacoesSelecionadas: [] as string[] },
    validationSchema: defaultValidationSchemas,
    onSubmit: async (values) => {
      console.log(">>> onSubmit disparado <<<");
      try {
        // 1. Pega email do localStorage
        const authRaw = localStorage.getItem('kt-auth-react-v');
        if (!authRaw) {
          alert('Não foi possível encontrar o auth no localStorage.');
          return;
        }
        let email;
        try {
          const authObj = JSON.parse(authRaw);
          email = authObj?.User?.Email;
        } catch (e) {
          alert('Erro ao ler o auth do localStorage.');
          return;
        }
        if (!email) {
          alert('Email do usuário não encontrado no localStorage.');
          return;
        }
        console.log('Email do usuário autenticado:', email);

        // 2. Busca userId pelo email
        const urlByEmail = `${process.env.REACT_APP_BACKEND_URL}/api/User/ByEmail/${email}`;
        const respByEmail = await fetch(urlByEmail, { method: 'GET', headers: { accept: '*/*' } });
        if (!respByEmail.ok) {
          alert('UserId não encontrado para este email!');
          return;
        }
        const userId = await respByEmail.json();
        console.log('userId retornado:', userId);

        // 3. Busca usuário completo pelo id
        const urlUser = `${process.env.REACT_APP_BACKEND_URL}/api/User/${userId}`;
        const respUser = await fetch(urlUser, { method: 'GET', headers: { accept: '*/*' } });
        if (!respUser.ok) {
          alert('Usuário não encontrado pelo id!');
          return;
        }
        const userData = await respUser.json();
        // 4. Busca organizações do usuário
        const urlOrgs = `${process.env.REACT_APP_BACKEND_URL}/api/UserOrganization/CorpByUser?userId=${userId}`;
        const respOrgs = await fetch(urlOrgs, { method: 'GET', headers: { accept: '*/*' } });
        if (!respOrgs.ok) {
          alert('Organizações não encontradas para este usuário!');
          return;
        }
        const orgs = await respOrgs.json();
        const idsOrgs = Array.isArray(orgs) ? orgs.map(o => o.OrganizationId) : [];
        console.log('Ids das organizações encontradas:', idsOrgs);

        // 5. Busca IDs das organizações selecionadas no formulário
        const orgNames = values.OrganizacoesSelecionadas || [];
        let orgIds = [];
        if (orgNames.length > 0) {
          const urlOrgIds = `${process.env.REACT_APP_BACKEND_URL}/api/Organization/OrgIdList`;
          console.log('Buscando IDs das organizações selecionadas:', orgNames);
          const respOrgIds = await fetch(urlOrgIds, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'accept': '*/*'
            },
            body: JSON.stringify(orgNames)
          });
          if (!respOrgIds.ok) {
            alert('Erro ao buscar IDs das organizações selecionadas!');
            return;
          }
          orgIds = await respOrgIds.json();
          console.log('IDs das organizações selecionadas:', orgIds);
        }

        // 6. Monta o body com os dados do usuário e as organizações
        const body = {
          ...values,
          IdOrganization: userData.IdOrganization,
          OrganizationIds: orgIds, // Adiciona os IDs das organizações selecionadas
          ...(values.Tipo === EnumUsuarioTipo['Microsoft Interno'] ? { Senha: '@Ab12345678' } : {}) // Define senha fixa apenas para Microsoft Interno
        };
        console.log('Body final enviado para adicionar:', body);
        // Log stringificado para checar caracteres especiais (ex: @) e encoding
        try {
          console.log('Body (stringified):', JSON.stringify(body));
        } catch (e) {
          console.log('Erro ao stringificar body para debug:', e);
        }

        await httpClient.request({
          method: RequestMethod.PUT,
          endpoint: '/Administracao/Usuario/Editar',
          data: body,
          ifSuccessRedirectTo: undefined // Removido redirecionamento automático
        });
        console.log(">>> Requisição de editar usuário enviada <<<");

        // Buscar o id do usuário criado
        const respNovoUserId = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/User/ByEmail/${values.Email}`, {
          method: 'GET',
          headers: { accept: '*/*' }
        });
        if (!respNovoUserId.ok) {
          alert('Não foi possível obter o id do usuário recém-criado!');
          return;
        }
        const novoUserId = await respNovoUserId.json();
        console.log('Id do usuário recém-criado:', novoUserId);

        // Deletar todas as organizações do usuário antes de adicionar as novas
        const respDeleteOrgs = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/UserOrganization/DeleteOrganizations?userId=${novoUserId}`, {
          method: 'DELETE',
          headers: {
            'accept': '*/*'
          }
        });
        if (!respDeleteOrgs.ok) {
          alert('Erro ao remover organizações antigas do usuário!');
          return;
        }
        console.log('Organizações antigas removidas com sucesso!');

        // Chamar API para adicionar organizações ao usuário
        if (orgIds && orgIds.length > 0) {
          const addOrgsBody = orgIds;
          const respAddOrgs = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/UserOrganization/AddOrganizations?userId=${novoUserId}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'accept': '*/*'
            },
            body: JSON.stringify(addOrgsBody)
          });
          if (!respAddOrgs.ok) {
            alert('Erro ao adicionar organizações ao usuário!');
            return;
          }
          console.log('Organizações adicionadas ao usuário com sucesso!');
        }

        // Redireciona após tudo
        navigate('/administracao/usuarios/lista');
        console.log(">>> Redirecionamento para lista de usuários <<<");
      } catch (error) {
        console.error("Erro ao enviar requisição:", error);
      }
    },
  })

  useEffect(() => {
    // Sempre que o tipo mudar, se for Microsoft Interno, limpa o campo Senha
    if (formik.values.Tipo === EnumUsuarioTipo['Microsoft Interno'] && formik.values.Senha !== '') {
      formik.setFieldValue('Senha', '');
    }
  }, [formik.values.Tipo]);


  const obterUsuario = async () => {
  try {
    console.log('Iniciando obterUsuario...');
    const response = await httpClient.request({
      method: RequestMethod.GET,
      endpoint: '/Administracao/Usuario/Obter',
      blockFree: true,
      queryObject: {
        tipo: informacao.tipo,
        idUsuario: informacao.idUsuario
      }
    })

    console.log('Resposta completa de obterUsuario:', JSON.stringify(response, null, 2));

    if (response.success && response.payload) {
      const emailUser = response.payload.Email;
      console.log('Email completo do usuário:', emailUser);

      // Apenas para Microsoft Interno
      if (response.payload.Tipo.toString() === EnumUsuarioTipo['Microsoft Interno'].toString()) {
              response.payload.Email = response.payload.Email.split('@')[0];
              response.payload.Senha = '@Ab12345678';
          }

          // Se for tela de ADICIONAR, não preenche tudo — só organizações
          if (informacao.title === 'Adicionar') {
              // Busca apenas as organizações (sem preencher o form)
              await buscarDadosAdicionais(emailUser);
          } else {
              // Edição / Visualização — preenche tudo
              const payloadComOrganizacoes = {
                ...response.payload,
                OrganizacoesSelecionadas: response.payload.OrganizacoesSelecionadas || []
              };
              formik.setValues(payloadComOrganizacoes);
              await buscarDadosAdicionais(emailUser);
          }
      }
  } catch (error) {
    console.error("Erro ao obter usuário:", error);
  }
}

  const obterIdUsuario = async (email: string) => {
    try {
      console.log('Email original:', email);
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/User/ByEmail/${email}`;
      console.log('URL completa:', url);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "*/*",
        },
      });

      const responseJson = await response.json();
      console.log("Resposta da API:", responseJson);

      // Se a resposta for diretamente um número
      if (typeof responseJson === 'number') {
        return responseJson;
      }
      // Se a resposta for um objeto com propriedade id
      else if (responseJson && responseJson.id) {
        return responseJson.id;
      } else {
        console.error("ID do usuário não encontrado na resposta:", responseJson);
        return null;
      }

    } catch (error) {
      console.error("Erro detalhado ao buscar ID do usuário:", error);
      return null;
    }
  };

  const buscarDadosAdicionais = async (emailUsuarioEditado: string) => {
    try {
      console.log('Buscando dados adicionais...');
      
      // Se for tela de EDITAR, busca organizações do usuário logado (gerente)
      let emailParaBuscarOrganizacoes = emailUsuarioEditado;
      
      if (informacao && informacao.title === 'Editar') {
        // Pega o email do usuário logado (gerente)
        const authRaw = localStorage.getItem('kt-auth-react-v');
        if (authRaw) {
          try {
            const authObj = JSON.parse(authRaw);
            const emailLogado = authObj?.User?.Email;
            if (emailLogado) {
              emailParaBuscarOrganizacoes = emailLogado;
              console.log('Modo EDITAR: buscando organizações do usuário logado:', emailLogado);
            }
          } catch (e) {
            console.error('Erro ao ler auth do localStorage:', e);
          }
        }
      }

      // Busca ID do usuário (logado para editar, ou editado para adicionar)
      const userId = await obterIdUsuario(emailParaBuscarOrganizacoes);
      console.log('ID do usuário para buscar organizações:', userId);

      if (userId && userId > 0) {
        try {
          // Busca organizações do usuário
          const url = `${process.env.REACT_APP_BACKEND_URL}/api/UserOrganization/CorpByUser?userId=${userId}`;
          console.log('URL da requisição de corporações:', url);

          const corpResponse = await fetch(url, {
            method: "GET",
            headers: {
              accept: "*/*",
            },
          });

          if (!corpResponse.ok) {
            throw new Error(`Erro na resposta: ${corpResponse.status} ${corpResponse.statusText}`);
          }

          const corpData = await corpResponse.json();
          console.log('Dados das corporações:', corpData);
          
          // Validar se corpData é um array
          if (Array.isArray(corpData)) {
            setOrganizacoes(corpData);
            
            // Se for EDITAR, buscar e marcar as organizações do usuário editado
            if (informacao && informacao.title === 'Editar') {
              const userIdEditado = await obterIdUsuario(emailUsuarioEditado);
              console.log('Buscando organizações do usuário editado, ID:', userIdEditado);
              
              if (userIdEditado && userIdEditado > 0) {
                const urlEditado = `${process.env.REACT_APP_BACKEND_URL}/api/UserOrganization/CorpByUser?userId=${userIdEditado}`;
                const respEditado = await fetch(urlEditado, {
                  method: "GET",
                  headers: { accept: "*/*" },
                });
                
                if (respEditado.ok) {
                  const orgsEditado = await respEditado.json();
                  console.log('Organizações do usuário editado:', orgsEditado);
                  
                  if (Array.isArray(orgsEditado)) {
                    const nomesOrgs = orgsEditado.map((org: any) => org.OrganizationName);
                    console.log('Marcando como selecionadas:', nomesOrgs);
                    formik.setFieldValue('OrganizacoesSelecionadas', nomesOrgs);
                  }
                }
              }
            }
          } else {
            console.error('corpData não é um array:', corpData);
            setOrganizacoes([]);
          }
        } catch (error) {
          console.error("Erro ao buscar corporações:", error);
        }
      } else {
        console.warn('Não foi possível buscar corporações pois o ID do usuário não foi obtido ou é inválido (ID:', userId, ')');
      }
    } catch (error) {
      console.error("Erro ao buscar dados adicionais:", error);
    }
  }

  const organizacoesPorCorporacao = useMemo(() => {
    try {
      console.log('Processando organizações:', organizacoes);
      
      if (!Array.isArray(organizacoes) || organizacoes.length === 0) {
        return [];
      }

      const grupos = organizacoes.reduce((acc, org) => {
        // Validar se org tem as propriedades necessárias
        if (!org || typeof org.Idcorporacao === 'undefined' || !org.CorporationName) {
          console.warn('Organização com dados inválidos:', org);
          return acc;
        }

        const corp = acc.find(c => c.Idcorporacao === org.Idcorporacao);
        if (corp) {
          corp.organizacoes.push(org);
        } else {
          acc.push({
            Idcorporacao: org.Idcorporacao,
            CorporationName: org.CorporationName,
            organizacoes: [org]
          });
        }
        return acc;
      }, [] as Array<{
        Idcorporacao: number;
        CorporationName: string;
        organizacoes: typeof organizacoes;
      }>);

      console.log('Grupos processados:', grupos);
      return grupos;
    } catch (error) {
      console.error('Erro ao processar organizações por corporação:', error);
      return [];
    }
  }, [organizacoes]);

  const obterPerfis = async () => {

    setPerfis([])

    await httpClient.request({
      method: RequestMethod.GET,
      endpoint: '/Administracao/Perfil/ObterParaSelect',
      blockFree: true
    }).then((response) => {
      if (response.success && response.payload) setPerfis(response.payload)
    })

  }

  const obterDados = async () => {
    try {
      console.log('Iniciando obterDados...');
      setBlocking(true);

      const promises = [];

      console.log(informacao);

      if (informacao && informacao.idUsuario && informacao.tipo) {
        promises.push(obterUsuario());
      }

      promises.push(obterPerfis());

      await Promise.all(promises);

    } catch (error) {
      console.error("Erro ao obter dados:", error);
    } finally {
      console.log('Finalizando obterDados...');
      console.log()
      setBlocking(false);
    }
  }

  useEffect(() => {
    if (!informacao || !informacao.idUsuario) {
      formik.setFieldValue("Perfis", [])
    }
  }, [formik.values.Tipo])

  useEffect(() => {
    obterDados()
  }, [informacao])

  // Verificação se informacao existe
  if (!informacao) {
    return (
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body'>
          <div className='alert alert-warning'>
            Informações do usuário não encontradas.
          </div>
          <button type='button' className='btn btn-secondary' onClick={() => navigate('/administracao/usuarios/lista')}>
            Voltar para lista
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>

        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>{informacao.title} Usuário</h3>
          </div>
        </div>

        <div className='card-body'>
          <FormikProvider value={formik}>
            <div className='w-100'>
              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  <div className='col-lg-6 fv-row mb-5'>
                    <label className='form-label required'>Tipo</label>
                    {informacao && informacao.title === 'Editar' ? (
                      <div className='form-control form-control-lg form-control-solid' style={{ backgroundColor: '#f5f5f5', color: '#7e8299', cursor: 'not-allowed' }}>
                        {EnumUsuarioTipo[formik.values.Tipo]}
                      </div>
                    ) : (
                      <Field
                        as='select'
                        name='Tipo'
                        className='form-select form-select-lg form-select-solid'
                        value={formik.values.Tipo}
                      >
                      {Object.keys(EnumUsuarioTipo)
                      .filter(key => EnumUsuarioTipo[parseInt(key)] !== 'Microsoft Externo')
                      .map(key => (
                          parseInt(key) > 0 && (
                          <option key={key} value={parseInt(key)}>
                              {EnumUsuarioTipo[parseInt(key)]}
                          </option>
                          )
                      ))}
                      </Field>
                    )}
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='Tipo' />
                    </div>
                  </div>
                  <div className='col-lg-6 fv-row mb-5'>
                    <label className='form-label required'>Nome</label>
                    <Field
                      name='Nome'
                      placeholder='Nome do usuário'
                      className='form-control form-control-lg form-control-solid'
                      value={formik.values.Nome}
                      disabled={informacao && informacao.title === 'Editar'}
                      style={informacao && informacao.title === 'Editar' ? { backgroundColor: '#f5f5f5', color: '#7e8299', cursor: 'not-allowed' } : {}}
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='Nome' />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className='col-lg-6 fv-row mb-5'>
                    <label className='form-label required'>Email</label>
                    <div className={formik.values.Tipo.toString() === EnumUsuarioTipo['Microsoft Interno'].toString() ? 'input-suffix-taggen' : ''}>
                      <Field
                        name='Email'
                        placeholder='Email do usuário'
                        className='form-control form-control-lg form-control-solid'
                        value={formik.values.Email}
                        disabled={informacao && informacao.title === 'Editar'}
                        style={informacao && informacao.title === 'Editar' ? { backgroundColor: '#f5f5f5', color: '#7e8299', cursor: 'not-allowed' } : {}}
                      />
                    </div>
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='Email' />
                    </div>
                  </div>
                    {Number(formik.values.Tipo) !== Number(EnumUsuarioTipo['Microsoft Interno']) && (
                      <div className='col-lg-6 fv-row mb-5'>
                        <label className='form-label required'>Senha</label>
                        <Field
                          name='Senha'
                          placeholder='Digite uma senha'
                          className='form-control form-control-lg form-control-solid'
                          value={formik.values.Senha}
                        />
                        <div className='text-danger mt-2'>
                          <ErrorMessage name='Senha' />
                        </div>
                      </div>
                    )}
                  <div className='col-lg-6 fv-row mb-5'>
                    <label className='form-label'>Perfis (Permissões)</label>
                    <Select
                      placeholder='Selecione...'
                      className='react-select-styled react-select-lg react-select-solid'
                      classNamePrefix='react-select'
                      noOptionsMessage={() => 'Nenhum registro encontrado'}
                      {...formik.getFieldProps('Perfis')}
                      options={perfis.map((data) => ({
                        value: data.Id,
                        label: data.Nome
                      }))}
                      value={perfis && perfis.length > 0 && formik.values.Perfis && formik.values.Perfis.length > 0 ? formik.values.Perfis.map((idPerfil) => ({
                        value: idPerfil,
                        label: perfis.find(x => x.Id === idPerfil)?.Nome ?? ''
                      })) : []}
                      isSearchable
                      isMulti
                      onChange={(e: any) => formik.setFieldValue("Perfis", e.map((data: any) => { return data.value }))}
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='Perfis' />
                    </div>
                  </div>
                </div>
                {organizacoesPorCorporacao.length > 0 && (
                  <div className="row mt-5">
                    <div className="col-12">
                      <h4 className="mb-4">Corporações e Organizações</h4>
                      <div className="list-group">
                        {organizacoesPorCorporacao.map((corp) => (
                        <div key={corp.Idcorporacao} className="list-group-item">
                            <div className="d-flex align-items-center mb-2">
                            <i className="bi bi-building me-2"></i>
                            <h5 className="mb-0">{corp.CorporationName}</h5>
                            </div>
                            <div className="ms-4">
                            {Array.isArray(corp.organizacoes) && corp.organizacoes.map((org) => (
                                <div key={org.OrganizationId} className="form-check py-1">
                                <input
                                type="checkbox"
                                className="form-check-input"
                                id={`org-${org.OrganizationName}`}
                                value={org.OrganizationName}
                                checked={Array.isArray(formik.values.OrganizacoesSelecionadas) && formik.values.OrganizacoesSelecionadas.includes(org.OrganizationName)}
                                onChange={(e) => {
                                    const selected = [...(formik.values.OrganizacoesSelecionadas || [])];
                                    if (e.target.checked) {
                                    selected.push(org.OrganizationName);
                                    } else {
                                    const index = selected.indexOf(org.OrganizationName);
                                    if (index > -1) selected.splice(index, 1);
                                    }
                                    formik.setFieldValue('OrganizacoesSelecionadas', selected);
                                }}
                                />
                                <label className="form-check-label" htmlFor={`org-${org.OrganizationName}`}>
                                {org.OrganizationName}
                                </label>
                                </div>
                            ))}
                            </div>
                        </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

              </form>
            </div>
          </FormikProvider>
        </div>
        <div className="card-footer py-4 d-flex justify-content-between">
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => navigate(-1)}
          >
            Voltar
          </button>
          <button
            type='button'
            onClick={async () => {
              console.log("Definindo Celular para 51999999999 antes da validação e do submit...");
              try {
                // Define o celular antes da validação para garantir que o schema o veja
                await formik.setFieldValue('Celular', '51999999999');
                console.log('Celular atualizado via formik:', formik.values.Celular);

                console.log("Chamando validação antes do submit...");
                const errors = await formik.validateForm();
                console.log('Erros de validação antes do submit:', errors);

                if (errors && Object.keys(errors).length > 0) {
                  console.warn('Formulário com erros, não será submetido.');
                  return;
                }

                console.log('Nenhum erro de validação — chamando formik.submitForm()');
                await formik.submitForm();
                console.log('formik.submitForm() finalizado');
              } catch (err) {
                console.error('Erro ao validar/enviar o formulário:', err);
              }
            }}
            className={`btn btn-lg btn-primary ${informacao && informacao.visualizar ? "d-none" : ""}`}
          >
            Editar
          </button>
        </div>
      </div>
    </>
  )
}

export { UsuarioEdit }

